import Head from 'next/head'

interface SEOProps {
  title: string
  description?: string
  keywords?: string
  canonicalUrl: string
  ogImageUrl?: string
  structuredData?: any
  noindex?: boolean
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImageUrl,
  structuredData,
  noindex
}) => {
  const fullTitle = `${title} | Commit Action`

  return (
    <Head>
      <title>{fullTitle}</title>
      <link rel="canonical" href={canonicalUrl} />

      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}
      {description && <meta property="og:description" content={description} />}

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:card" content="summary_large_image" />
      {description && <meta name="twitter:description" content={description} />}
      {ogImageUrl && <meta property="twitter:image" content={ogImageUrl} />}

      {/* Structured Data */}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}
    </Head>
  )
}
